module.exports = __webpack_public_path__ + "assets/img/default-room-brandless.8da91a6b.jpg";